import { renderReferralApplication, renderReferrerApplication } from '../renderApplication';

import { createContext } from './createContext';
import { createReferralApplicationState, createReferrerApplicationState } from '../applicationState';

function toggleSystemThemeClass(shouldEnable: boolean): void {
  document.documentElement.classList.toggle('design-theme--system', shouldEnable);
}

export function runApp(): void {
  const context = createContext();
  const { custom } = context;
  const shouldEnableSystemTheme = Boolean(custom.isSystemThemeEnabled);

  toggleSystemThemeClass(shouldEnableSystemTheme);

  if (custom.pageType === 'referrer') {
    const store = createReferrerApplicationState(context);

    renderReferrerApplication({ context, store });

    return;
  }

  if (custom.pageType === 'referral') {
    const store = createReferralApplicationState(context);

    renderReferralApplication({ context, store });

    return;
  }
}
